import type { ComponentProps } from "react";

export function ClayLogo(props: ComponentProps<"svg">) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <title>Clay</title>
      <path fill="#4BC5EA" d="M1 23V16A11 11 0 0 1 23 16V23Z" />
      <path fill="#F16060" d="M4 23V16A8 8 0 0 1 20 16V23Z" />
      <path fill="#FBC94C" d="M7 23V16A5 5 0 0 1 17 16V23Z" />
    </svg>
  );
}
